export default "__VITE_ASSET__DBuUDPID__"